import {
    /** FETCH APPLICATION  */
    FETCH_SAVEAPPLICATIONRESULT_FULFILLED,
    FETCH_SAVEAPPLICATIONRESULT_REJECTED,
    FETCH_SAVEAPPLICATIONRESULT_PENDING,
    RESET_SAVEAPPLICATIONRESULT,
  } from "../../actions/application/saveApplicationResult";
  const initialState = {
    done: false,
    error: false,
    spinner: false
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SAVEAPPLICATIONRESULT_PENDING:
        return {
          done: false,
          spinner: true,
          error: false,
        };
      case FETCH_SAVEAPPLICATIONRESULT_FULFILLED:
        return {
          ...state,
          saveApplicationResult: action.payload,
          done: true,
          error: false,
          spinner : false
        };
      case FETCH_SAVEAPPLICATIONRESULT_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner : false
        };
      case RESET_SAVEAPPLICATIONRESULT:
        return {
          initialState,
          done: false,
          error: false,
          spinner : false
        };
      default:
        return state;
    }
  };
  